import { render, staticRenderFns } from "./BookingSurchargeModal.vue?vue&type=template&id=10967d47&scoped=true&"
import script from "./BookingSurchargeModal.vue?vue&type=script&lang=js&"
export * from "./BookingSurchargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10967d47",
  null
  
)

export default component.exports